import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { EnquiryProvider } from "@/context/EnquiryContext";
import { setLenis, scrollToTop } from "@/lib/scroll";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import FloatingButtons from "@/components/site/FloatingButtons";
import Home from "@/pages/Home";
import ProductDetail from "@/pages/ProductDetail";
import { Blog, BlogPost } from "@/pages/Blog";
import AdminLeads from "@/pages/AdminLeads";
import Legal from "@/pages/Legal";

function LenisBridge() {
  const lenis = useLenis();
  useEffect(() => { setLenis(lenis); }, [lenis]);
  return null;
}

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollToTop();
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products/:slug" element={<ProductDetail />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/privacy" element={<Legal type="privacy" />} />
        <Route path="/terms" element={<Legal type="terms" />} />
        <Route path="/admin/leads" element={<AdminLeads />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <FloatingButtons />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <BrowserRouter>
          <EnquiryProvider>
            <LenisBridge />
            <ScrollManager />
            <Shell />
            <Toaster position="top-center" richColors closeButton />
          </EnquiryProvider>
        </BrowserRouter>
      </ReactLenis>
    </div>
  );
}

export default App;
